import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/privacy-policy/page.jsx");
